export default function SkeletonDashboard() {
  return (
    <div className="space-y-6 w-full animate-in fade-in duration-500">
      {/* SECTION 1: STATISTIC CARDS (4 Grid) */}
      <section className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {[...Array(4)].map((_, index) => (
          <div
            key={index}
            className="p-4 rounded-xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 shadow-sm"
          >
            <div className="flex justify-between items-start">
              <div className="space-y-2 w-full">
                {/* Title Skeleton */}
                <div className="skeleton h-3 w-1/2 rounded-full" />
                {/* Value Skeleton */}
                <div className="skeleton h-8 w-3/4 rounded-md" />
              </div>
              {/* Icon Skeleton */}
              <div className="skeleton h-10 w-10 rounded-full shrink-0" />
            </div>
          </div>
        ))}
      </section>

      {/* SECTION 2: HEADER & SEARCH */}
      <section className="flex flex-col sm:flex-row justify-between items-end sm:items-center gap-4">
        <div className="space-y-2 w-full sm:w-auto">
          {/* Page Title Skeleton */}
          <div className="skeleton h-6 w-48 rounded-md" />
          {/* Subtitle Skeleton */}
          <div className="skeleton h-3 w-64 rounded-md" />
        </div>

        <div className="flex items-center gap-2 w-full sm:w-auto">
          {/* Search Input Skeleton */}
          <div className="skeleton h-10 w-full sm:w-[250px] rounded-md" />
          {/* Filter Button Skeleton */}
          <div className="skeleton h-10 w-10 sm:w-24 rounded-md" />
          {/* Export Button Skeleton */}
          <div className="skeleton h-10 w-10 sm:w-24 rounded-md" />
        </div>
      </section>

      {/* SECTION 3: TABLE SKELETON */}
      <section className="rounded-xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 shadow-sm overflow-hidden">
        {/* Table Header */}
        <div className="p-4 border-b border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-900/50 flex gap-4">
          {[...Array(5)].map((_, i) => (
            <div key={i} className="skeleton h-4 w-full rounded-md" />
          ))}
        </div>

        {/* Table Body Rows */}
        <div className="divide-y divide-slate-100 dark:divide-slate-800">
          {[...Array(8)].map((_, rowIndex) => (
            <div key={rowIndex} className="p-4 flex gap-4 items-center">
              {/* Row Cells */}
              <div className="skeleton h-4 w-[15%] rounded-md" />
              <div className="skeleton h-4 w-[25%] rounded-md" />
              <div className="skeleton h-4 w-[20%] rounded-md" />
              <div className="skeleton h-4 w-[15%] rounded-md" />
              <div className="skeleton h-4 w-[10%] rounded-md" />
              <div className="skeleton h-8 w-[15%] rounded-full" />{" "}
              {/* Action Button/Badge */}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
